import React from 'react'
import './experience.css'
import { HiBadgeCheck } from 'react-icons/hi'
import { skills } from '../../data'

const Experince = () => {
  return (
    <section id='experience'>
      <h5>Skills I Have</h5>
      <h2>My Experience</h2>
      <div className="container experience__container">
        {skills.map(tech => (
          <div className="experience__card" key={tech.id}>
            <h3>{tech.techName}</h3>
            <div className="experience__content">
              {tech.skills.map(skill => (
                <article className='experience__details' key={skill.id}>
                  <HiBadgeCheck className='experience__details-icon' />
                  <div>
                    <h4>{skill.name}</h4>
                    <small className='text-light'>{skill.level}</small>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Experince
